module.exports = __webpack_public_path__ + "media/images/logo/payment_channel/wallet_dana-60e5a343934d1da8f4b50f69f7ee2cb3.svg";